<template>
    <v-container fluid fill-height :class="$vuetify.breakpoint.xsOnly ? 'container-menor' : ''">
        <v-layout flex align-center justify-center>
            <v-flex xs12 sm6 md4>
                <v-toolbar color="primary">
                    <v-toolbar-title class="white--text">Apisul Seguros</v-toolbar-title>
                </v-toolbar>
                <v-card>
                    <v-card-text>
                        <v-form ref="esqueciSenhaForm" v-model="esqueciSenhaFormValid">
                            <v-container grid-list-lg>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <span class="themeGrey--text">Insira o e-mail de cadastro. Em breve enviaremos instruções para seu e-mail</span>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field label="E-mail"
                                        v-model="esqueciSenhaModel.email"
                                        :rules="regras.email"
                                        @keydown.enter.prevent=""
                                        validate-on-blur=""
                                        required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-flex xs12 md6 text-md-left text-xs-left>
                            <v-btn flat id="voltar" color="primary" @click="voltar"> Voltar </v-btn>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loadingEnviar" 
                            @click.native="enviarRecuperacaoSenha"
                            :disabled="!esqueciSenhaFormValid || (snackbar.visivel && snackbar.sucesso)"
                            color="primary">
                            Enviar
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-snackbar
                    :timeout="6000"
                    :color="snackbar.sucesso ? 'success' : 'error'"
                    multi-line
                    v-model="snackbar.visivel">
                    {{ snackbar.mensagem }}
                    <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
                </v-snackbar>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'login',
    data: () => {
        return {
            esqueciSenhaFormValid: false,
            loadingEnviar: false,
            snackbar: {
                visivel: false,
                mensagem: '',
                sucesso: false
            },
            esqueciSenhaModel: {
                email: ''
            },
            regras: {
                email: [
                    v => !!v || 'Você não pode deixar este campo em branco',
                    v => /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/.test(v) || 'Formato de e-mail inválido'
                ]
            },
        }
    },
    watch: {
        'snackbar.visivel': function (newValue, oldValue) {
            if (oldValue && !newValue && this.snackbar.sucesso) {
                this.$router.push('/Login');
            }
        }
    },
    methods: {
        voltar: function() {
            this.$router.push("/login");
        },
        enviarRecuperacaoSenha: function () {
            const self = this;
            self.loadingEnviar = true;
            axios.get(`${process.env.URL_USUARIOMS}/v1/no-auth/verificaEmailCadastrado?email=${self.esqueciSenhaModel.email}`)
            .then((response) => {
                const existe = response.data;
                if (existe) {
                    axios.post(`${process.env.URL_USUARIOMS}/v1/no-auth/resetaSenha?email=${self.esqueciSenhaModel.email}`)
                    .then((response) => {
                        self.snackbar.visivel = true;
                        self.snackbar.sucesso = true;
                        self.snackbar.mensagem = 'As instruções foram enviadas para o e-mail';
                        self.loadingEnviar = false;
                    })
                    .catch((err) => {
                        self.snackbar.visivel = true;
                        self.snackbar.sucesso = false;
                        self.snackbar.mensagem = 'Erro ao enviar e-mail de recuperação';
                        self.loadingEnviar = false;                        
                    });
                } else {
                    self.snackbar.visivel = true;
                    self.snackbar.sucesso = false;
                    self.snackbar.mensagem = 'Usuário não cadastrado';
                    self.loadingEnviar = false;                    
                }
            }).catch((err) => {
                self.snackbar.visivel = true;
                self.snackbar.sucesso = false;
                self.snackbar.mensagem = 'Erro ao enviar e-mail de recuperação';
                self.loadingEnviar = false;                
            });
        }
    }
}
</script>

<style scoped>
.container-menor {
    padding: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/login/EsqueciSenha.vue